import {isPlatformBrowser} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {APP_ID, Inject, NgModule, PLATFORM_ID} from '@angular/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {BrowserModule} from '@angular/platform-browser';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CachingModule} from './caching/caching.module';
import {CoreModule} from './core/core.module';
import {ProductsModule} from './products/products.module';
import {QuoteListModule} from './quotes/quote-list-module';
import {metaReducers, reducers} from './reducers';
import {WINDOW_PROVIDERS} from './shared/services/window.service';
import {SharedModule} from './shared/shared.module';
import {UserModule} from './user/user.module';
import {GalleryModule} from 'ng-gallery';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        SharedModule,
        BrowserModule.withServerTransition({
            appId: 'hering-b2b-app'
        }),
        BrowserAnimationsModule,
        FlexLayoutModule,
        HttpClientModule,
        StoreModule.forRoot(reducers, {metaReducers}),
        EffectsModule.forRoot([]),
        CoreModule,
        CachingModule,
        UserModule,
        ProductsModule.forRoot(),
        QuoteListModule,
        AppRoutingModule,
        GalleryModule
    ],
    providers: [WINDOW_PROVIDERS],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(APP_ID) private appId: string) {
        const platform = isPlatformBrowser(platformId) ?
            'in the browser' : 'on the server';
        console.log(`Running ${platform} with appId=${appId}`);
    }
}
